export default "__VITE_ASSET__DOFZJDFL__"